import React from 'react';
import { styled as styled2 } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

export type Props = {
	avatarUri: string;
	label: string;
	messages: {
		avatarAccessibleAlt: MessageDescriptor;
		avatarAriaLabel: MessageDescriptor;
		avatarAlt: MessageDescriptor;
		editAvatar: MessageDescriptor;
	};
	onEdit: () => void;
	tooltipDelay?: number;
};

export const AvatarIcon = ({ onEdit, messages, avatarUri, label, tooltipDelay }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<EditableWrapper>
			<Tooltip content={formatMessage(messages.avatarAccessibleAlt)} delay={tooltipDelay}>
				<Avatar
					src={avatarUri}
					name={formatMessage(messages.avatarAlt)}
					label={formatMessage(messages.avatarAriaLabel, {
						issueType: label,
					})}
					appearance="square"
					size="small"
					onClick={onEdit}
				/>
			</Tooltip>
		</EditableWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled2.div({
	display: 'inline-flex',
	marginTop: token('space.100'),
	/* Avatar uses padding equal to the border width size. Let's add a negative margin of the same size to keep it aligned. */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	marginLeft: token('space.negative.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EditableWrapper = styled2(Wrapper)({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'*:focus': {
		backgroundColor: 'transparent',
	},
});
